import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	font-size: 1rem;
	color: ${({ theme }) => theme.header.colors.background};
`;

export const Field = () => {
	return <Wrapper>textbox</Wrapper>;
};
